<div class="wrapper">
  <div class="color-line"></div>
  <app-topbar
    (mobileMenuButtonClicked)="onToggleMobileMenu()"
  />

  <horizontal-nav />
  <div class="page-content">
    <div class="page-container">
      <router-outlet />
    </div>

    <app-footer class="mt-auto" />
  </div>
</div>
